import FastFacts from './FastFacts';

export default FastFacts;
